import React, { useEffect } from 'react';

/**
 * This page is the LWA redirect target. After successful auth, Amazon redirects here
 * with ?success=true&expiry=SECONDS&csrf_token=TOKEN.
 * We store the auth state in localStorage (which triggers the storage event in the parent window)
 * and close this window.
 */
const CloseWindow: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get('success');
    const expiry = params.get('expiry');
    const csrfToken = params.get('csrf_token');

    if (success === 'true' && expiry) {
      try {
        const expiryTimeMs = Number(expiry) * 1000;
        const existingJSON = localStorage.getItem('authState');
        const existing = existingJSON ? JSON.parse(existingJSON) : {};
        const authState = {
          ...existing,
          expiryTime: expiryTimeMs,
          csrfToken: csrfToken || undefined,
        };
        localStorage.setItem('authState', JSON.stringify(authState));
      } catch (e) {
        console.error('Failed to persist auth state in popup:', e);
      }
    }

    window.close();
  }, []);

  return <p>Completing sign in...</p>;
};

export default CloseWindow;
